module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/sprakplay-d66bb69136fe39fd5a68f9a52de5fba7.jpg";